import { render, staticRenderFns } from "./ServiceDetailExtract.vue?vue&type=template&id=3c0cdff5&"
import script from "./ServiceDetailExtract.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailExtract.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailExtract.vue?vue&type=style&index=0&id=3c0cdff5&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0cdff5')) {
      api.createRecord('3c0cdff5', component.options)
    } else {
      api.reload('3c0cdff5', component.options)
    }
    module.hot.accept("./ServiceDetailExtract.vue?vue&type=template&id=3c0cdff5&", function () {
      api.rerender('3c0cdff5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServiceDetailExtract.vue"
export default component.exports